
import React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import Result from '../Result'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import {
    ResultsSliderElement
} from './ResultsSliderStyles'

const ResultsSlider = props => {
    const data = useStaticQuery(graphql`
        {
            allResultsJson {
                nodes {
                    title
                    courtHouse
                    amount
                    resultBody
                }
            }
        }
    `)

    var settings = {
        centerMode: true,
        initialSlide: 0,
        arrows: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                  slidesToShow: 3,
                  dots: true
                }
            },
            {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                }
            },
            {
                breakpoint: 350,
                settings: {
                  slidesToShow: 1,
                  centerMode: false
                }
            },
        ]
    };

    const parseAmount = str => parseInt(str.replace(/[^0-9]/g, ''), 10) || 0

    const sorted = [...data.allResultsJson.nodes]
        .filter(r => r.amount.startsWith('$'))
        .sort((a, b) => parseAmount(b.amount) - parseAmount(a.amount))

    // Move 2nd and 3rd largest to end so they wrap around to peek left of 1st in centerMode
    const sortedResults = sorted.length > 2
        ? [sorted[0], ...sorted.slice(3), sorted[2], sorted[1]]
        : sorted

    return (
        <ResultsSliderElement>
            <Slider {...settings}>
                {sortedResults.map(resultSlide => (
                    <Result
                        key={resultSlide.title}
                        name={resultSlide.title}
                        courtName={resultSlide.courtHouse}
                        resultAmount={resultSlide.amount}
                        body={resultSlide.resultBody}
                    />
                ))}
            </Slider>
        </ResultsSliderElement>
    )
}

export default ResultsSlider
